import { useQuery } from "@tanstack/react-query";
import { accountManagerApi } from "../api/accountManagerApi";
import { queryKeys } from "../../../api/queryKeys";

export const useAMCustomers = () => {
  return useQuery({
    queryKey: queryKeys.accountManager.customers(),
    queryFn: () => accountManagerApi.customers.list(),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
